import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine';
import { useMediaQuery } from '@mui/material';
import ArrowIcon from '../assets/icons/arrow_bottom';

import style from './style.module.scss';

const BreadcrumbBlock = ({ items }) => {
    const { isEditing } = useEditor();
    const isMobile = useMediaQuery(`(max-width:${style.mobileBreakpoint})`);

    if (isEditing) return <BlockWrapper.Div className={style.admin}>Fil d'ariane</BlockWrapper.Div>;
    if (isMobile) return null;

    return (
        <BlockWrapper.Ul className={style.breadcrumb}>
            {items.map((el, i) => {
                if (el.url) {
                    return [
                        <li key={el.id} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                            <a className={style.link} href={isEditing ? false : el.url} itemProp="item">
                                <span itemProp="name" dangerouslySetInnerHTML={{ __html: el.name }} />
                            </a>
                            <meta itemProp="position" content={i + 1} />
                        </li>,
                        <ArrowIcon key={el.id + '_arrow'} className={style.icon} />,
                    ];
                } else {
                    return (
                        <li key={el.id}>
                            <span
                                className={style.actual}
                                itemProp="name"
                                dangerouslySetInnerHTML={{ __html: el.name }}
                            />
                            <meta itemProp="position" content={i + 1} />
                        </li>
                    );
                }
            })}
        </BlockWrapper.Ul>
    );
};

export default defineBlock({
    Block: BreadcrumbBlock,
    smartProps: {},
    setup: {
        title: "Fil d'ariane",
    },
});
